import { BellRing } from 'lucide-react';

import { PageHeader } from '../../../components/shared';
import { useActionPermission } from '../../../hooks/usePermission';
import { useT } from '../../../i18n';
import { useAuthStore } from '../../../stores/auth';
import { useTenantCuaToi } from '../../auth/hooks/useTenantCuaToi';
import { VAI_TRO_QUAN_TRI_TENANT } from '../../auth/nghiep-vu/quyen-cong-tenant';
import { KhongCoTenant } from '../../nhat-ky/components/KhongCoTenant';
import { TrungTamCanhBao } from '../components/TrungTamCanhBao';

/**
 * "Cảnh báo và thông báo" của cổng tenant — `/he-thong/canh-bao` (ADR-0102 mục 13). Chỉ quản trị tổ chức cấu hình
 * (ADR-0102 mục 12): cùng luật với Cài đặt bảo mật — role lớp 1 `TENANT_ADMIN`, hoặc `SECURITY_CONFIG.UPDATE`.
 * Backend vẫn kiểm. Không dùng `/thong-bao`, đường đó thuộc màn thông báo của người dùng.
 */
export function CanhBaoTenantView() {
  const { t } = useT();
  const { tenantId, dangTai } = useTenantCuaToi();
  const laQuanTriToChuc = useAuthStore((s) => s.user?.vaiTroLop1?.includes(VAI_TRO_QUAN_TRI_TENANT) ?? false);
  const duocSua = useActionPermission('SECURITY_CONFIG', 'UPDATE') || laQuanTriToChuc;

  return (
    <div className="flex h-full flex-col bg-subtle">
      <div className="flex-1 space-y-4 overflow-y-auto p-4 pb-12">
        <PageHeader
          breadcrumb={[{ label: t('nav.nhom.cauHinhHeThong') }, { label: t('canhBao.nhanNavTenant') }]}
          titleIcon={<BellRing size={18} className="text-primary-600" />}
          title={t('canhBao.tieuDe')}
          subtitle={t('canhBao.moTaTenant')}
        />
        {tenantId ? <TrungTamCanhBao pv="tenant" duocSua={duocSua} /> : dangTai ? null : <KhongCoTenant />}
      </div>
    </div>
  );
}
